export const numeric = /\d/
export const specialCharcaters = /[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/
export const alphabet = /^$|^[A-Za-z ]+$/g
export const emailCheck = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
